import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, glass, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Menu', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      background: 'transparent !important',

      [`${componentCls}-item`]: {
        borderRadius: '4px !important',
        transition,
        position: 'relative' as const,

        '&:hover': {
          background: `${glass.hover} !important`,
          color: `${blue[300]} !important`,
        },

        // 选中态：左侧荧光条 + 蓝色背景
        [`&${componentCls}-item-selected`]: {
          background: `${glass.selected} !important`,
          color: `#fff !important`,

          '&:after': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '15%',
            bottom: '15%',
            width: 3,
            background: blue[500],
            boxShadow: `0 0 6px ${blue[500]}80`,
            borderRadius: 2,
          },
        },
      },

      [`${componentCls}-submenu-title`]: {
        borderRadius: '4px !important',
        transition,

        '&:hover': {
          background: `${glass.hover} !important`,
          color: `${blue[300]} !important`,
        },
      },

      [`${componentCls}-item-group-title`]: {
        color: `#475569 !important`,
        fontSize: '11px',
        textTransform: 'uppercase' as const,
        letterSpacing: '1px',
      },
    },
  }
})
